<eiq-toggle-buttons [toggleList]="languageList$()" [toggleCtrl]="languageControl" testId="translations-language" />
